import {
  IBlackjackGame,
  IBlackjackPlayerCardsObject,
  IBlackjackTicketsObject,
  TBlackjackGameStatus,
} from "@api/types/blackjack";
import getReducersLayout from "@redux/utils/getReducersLayout";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: IBlackjackGame = {
  game_metadata: {
    max_players: 0,
    creator: null,
    started_at: 0,
    created_at: 0,
    ended_at: 0,
    status: "active",
    is_Private: false,
  },
  uid: "",
  players: [],
  prepay_rate: 0,
  prepay_amount: 0,
  cost: 0,
  referral_stakes_periods: 0,
  referral_wagered_in_period: 0,
  cards_order: [],
  ticket_id: "",
  ticket_hash: "",
  auto_stand_at: 0,
  secret_hash: "",
  ticket_verify_url: "",
};

const blackjackSlice = createSlice({
  name: "blackjack",
  initialState,
  reducers: {
    ...getReducersLayout(initialState),
    storePlayerCards: (
      state,
      { payload: { index, cards } }: PayloadAction<IPlayerCardsPayload>
    ) => {
      state.players![index].cards = cards;
    },
    storePlayerTickets: (
      state,
      { payload: { index, tickets } }: PayloadAction<IPlayerTicketsPayload>
    ) => {
      state.players![index].tickets = tickets;
    },
    storePlayerStatus: (
      state,
      { payload: { index, status } }: PayloadAction<IPlayerStatusPayload>
    ) => {
      state.players![index].status = status;
    },
    storePlayerReadyToPlay: (
      state,
      { payload: playerId }: PayloadAction<string>
    ) => {
      state.players = state.players!.map((player) =>
        player.user.id === playerId ? { ...player, readyToPlay: true } : player
      );
    },
  },
});

export const {
  resetData,
  setData,
  storePlayerReadyToPlay,
  storePlayerStatus,
  storePlayerTickets,
  storePlayerCards,
} = blackjackSlice.actions;

export default blackjackSlice;

/* Custom Payloads */

interface IPlayerPayloadBase {
  index: number;
}

export interface IPlayerTicketsPayload extends IPlayerPayloadBase {
  tickets: IBlackjackTicketsObject[];
}

export interface IPlayerStatusPayload extends IPlayerPayloadBase {
  status: TBlackjackGameStatus;
}

export interface IPlayerCardsPayload extends IPlayerPayloadBase {
  cards: IBlackjackPlayerCardsObject[];
}
